import React from "react";
import { View, TextInput, Animated, StyleSheet, Text } from "react-native";

class CustomInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
      input: "",
      validationError: "",
      textEdited: false
    };

    this._animatedIsFocused = new Animated.Value(
      this.props.value === "" || this.props.value == null ? 0 : 1
    );
  }
  handleFocus = () => {
    this.setState(
      { isFocused: true },
      () =>
        typeof this.props.commentFocused == "function" &&
        this.props.commentFocused(true)
    );
  };
  handleBlur = () => {
    if(this.props.onBlur){
      this.props.onBlur()
    }
    this.setState(
      { isFocused: false },
      () =>
        typeof this.props.commentFocused == "function" &&
        this.props.commentFocused(false)
    );
  };
  componentDidUpdate(prev) {
    Animated.timing(this._animatedIsFocused, {
      toValue: this.state.isFocused || this.props.value !== "" ? 1 : 0,
      duration: 200,
      useNativeDriver: false // <-- Add this
    }).start();
    if (!this.state.textEdited && this.props.value != prev.value) {
      this.validateText(this.props.value, false);
    }
    if(this.props.editable != prev.editable){
      this.validateText(this.props.value, false);
    }
  }
  componentDidMount() {
    if (this.props.onRef != null) {
      this.props.onRef(this);
    }
    if (this.props.value != "") {
      this.validateText(this.props.value, false);
    }
  }
  onSubmitEditing() {
   if (this.props.onSubmitEditing != null) this.props.onSubmitEditing();
  }

  focus() {
    this.textInput.focus();
  }

  onTextChanged = text => {
    this.validateText(text, true);
  };

  validateText = (text, updateProps) => {
    let newText = text;
    var validationError = "";

    let validate = true;
    if (this.props.ifEmptyNoPatternCheck) {
    if (text == "" || text == null) validate = false;
    }
    if (
      this.props.pattern &&
      this.props.pattern != "" &&
      !this.props.pattern.test(text)
    ) {
      validationError = this.props.errorMessage;
      this.setState({ validationError: validationError });
    }
    if (
      this.props.patternDif &&
      this.props.patternDif != "" &&
      this.props.patternDif.test(text)
    ) {
      validationError = this.props.errorMessage;
      this.setState({ validationError: validationError });
    }
    if (updateProps) {
      this.setState({
        input: newText,
        validationError: validationError,
        textEdited: true
      });
      this.props.onValueChanged(newText);
    } else {
      this.setState({ validationError: validationError });
    }
    return newText;
  };
  render() {
    const { label, bold, ...props } = this.props;
    return (
      <View style={{width:props.width100 ? '100%' :'auto',  }}>
          <View style={{flexDirection:this.props.flexDirection ? this.props.flexDirection : 'row',width:props.width100 ? '100%' :'auto',marginBottom:5}}>
          <Animated.Text style={[styles.labelStyle, {}]}>
          {label}
          {this.props.mandatoryField ? (
            <Animated.Text
              style={[
                styles.inlineError,
                { color: "#f00", fontSize:15,fontWeight:"500" }
              ]}
            >
              {" *"}
            </Animated.Text>
          ) : null}
        </Animated.Text>
        <TextInput
          {...props}
          style={[
            this.state.isFocused
              ? styles.focusedTextInput
              : styles.textInput && this.state.validationError
              ? styles.focusedTextInputError
              : styles.textInput,
            this.props.style
          ]}
          onFocus={() => {
            this.handleFocus();
            this.props.onFocus && this.props.onFocus();
          }}
          onBlur={() => {
            if (
              this.props.value != "null" &&
              this.props.value != null &&
              this.props.value != ""
            )
              this.onTextChanged(this.props?.value?.trim());
            this.handleBlur();
          }}
          blurOnSubmit
          onChangeText={this.onTextChanged}
          value={this.props.value != "null" ? this.props.value : ""}
          returnKeyType={this.props.returnKeyType}
          autoFocus={this.props.autoFocus}
          onSubmitEditing={({ nativeEvent }) => {
            this.onTextChanged(nativeEvent.text.trim());
            this.onSubmitEditing.bind(this);
          }}
          multiline={this.props.multiline}
          ref={input => (this.textInput = input)}
          autoCapitalize ={this.props.autoCapitalize}
          maxLength={this.props.maxLength}
          secureTextEntry={this.props.hidePassword}
          contextMenuHidden={this.props.contextMenuHidden}
          placeholder={this.props.placeholder}
          editable={props.editable}
        />
          </View>
          
        <View>
        {this.props.requiredEndText ? (
          <Text
            style={{
              color: "#9c9ea0",
              fontSize: 19,
              alignSelf: "flex-end",
              marginTop: 0
            }}
          >
            {this.props.endText}
          </Text>
        ) : null}
        {this.state.validationError != "" ? (
          <Text style={styles.inlineError}>{this.state.validationError}</Text>
        ) : null}
        </View>
       
      </View>
    );
  }
}

export default CustomInput;

const styles = StyleSheet.create({
  labelStyle: {
    fontFamily: 'Inter',
    fontWeight: "500",
    fontSize:14,
    paddingTop:5,
    flex: '0.8',
    color: '#757575',
  },
  focusedTextInput: {
    borderRadius: 10,
    backgroundColor:'white',
    borderWidth: 1,
    borderColor: "#02122C",
    marginBottom: 5,
    paddingHorizontal: 20,
    color: '#757575',
    fontFamily: 'Inter',
    fontSize: 14,
    height: 40
  },
  focusedTextInputError: {
    borderRadius: 10,
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: "#FF6E6E",
    marginBottom: 5,
    paddingHorizontal: 20,
    color: '#757575',
    fontFamily: 'Inter',
    fontSize: 14,
    height: 40
  },
  textInput: {
    borderRadius: 10,
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#ccc',
    marginBottom: 5,
    paddingHorizontal: 20,
    color: '#757575',
    fontFamily: 'Inter',
    fontSize: 14,
    height:  40
  },
  inlineError: {
    fontFamily: 'Inter',
    fontSize: 12,
    color: '#db1a1a',
    marginTop:  3,
    marginLeft: 0,
  }
});
